export const homeRoutes = [
  {
    id: 1,
    text: "How-to",
    to: "/how-to-use",
  },
  {
    id: 2,
    text: "Login",
    to: "/login",
  },
  {
    id: 3,
    text: "Signup",
    to: "/signup",
  },
];

export const appRoutes = [
  {
    id: 1,
    text: "Dictionary",
    to: "/app/dictionary",
  },
  {
    id: 2,
    text: "Dashboard",
    to: "/app/dashboard",
  },
  {
    id: 3,
    text: "Tests",
    to: "/app/testVerbum",
  },
  {
    id: 4,
    text: "Practice",
    to: "/app/practice",
  },
  {
    id: 5,
    text: "Vocabulary",
    to: "/app/vocabulary",
  },
];

export const sideNavLogout = {
  id: 4,
  text: "Logout",
  to: "/logout",
};

export const footerRoutes = [
  {
    id: 0,
    text: "Vision",
    to: "/vision",
  },
  {
    id: 1,
    text: "Privacy",
    to: "/privacy",
  },
  {
    id: 2,
    text: "Terms",
    to: "/terms-of-use",
  },
];
